// extracted by mini-css-extract-plugin
module.exports = {"navBar":"styles_navBar__lzea7","tabLine":"styles_tabLine__EbEI_"};